import React from "react";

import type { JSX } from "react";

function ThreeFilesIcon(): JSX.Element {
  return (
    <svg
      fill="none"
      height="166"
      viewBox="0 0 229 166"
      width="229"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="117" cy="80.5" fill="var(--surface-muted)" r="80" />
      <circle cx="33" cy="20.5" fill="var(--surface-muted)" r="8" />
      <circle cx="205" cy="126.5" fill="var(--surface-muted)" r="6" />
      <circle cx="32" cy="138.5" fill="var(--surface-muted)" r="10" />
      <circle cx="217" cy="38.5" fill="var(--surface-muted)" r="10" />
      <circle cx="198" cy="11.5" fill="var(--surface-muted)" r="7" />
      <g filter="url(#filter0_dd_10643_40376)">
        <path
          d="M63.0793 124.714L115.531 100.255C118.164 99.0274 119.303 95.897 118.075 93.2636L87.0998 26.8362L66.1244 19.2018L23.2097 39.2133C20.5762 40.4413 19.4369 43.5716 20.6649 46.2051L56.0875 122.169C57.3155 124.802 60.4458 125.942 63.0793 124.714Z"
          fill="url(#paint0_linear_10643_40376)"
        />
        <path
          d="M66.125 19.2017L87.1004 26.8361L72.7955 33.5066L66.125 19.2017Z"
          fill="var(--border-strong)"
        />
      </g>
      <g filter="url(#filter1_dd_10643_40376)">
        <path
          d="M88.1519 106.839H146.025C148.931 106.839 151.287 104.484 151.287 101.578V28.2837L135.503 12.5H88.1519C85.2462 12.5 82.8906 14.8555 82.8906 17.7612V101.578C82.8906 104.484 85.2462 106.839 88.1519 106.839Z"
          fill="url(#paint1_linear_10643_40376)"
        />
        <path
          d="M135.504 12.5L151.288 28.2837H135.504V12.5Z"
          fill="var(--border-strong)"
        />
      </g>
      <g filter="url(#filter2_dd_10643_40376)">
        <path
          d="M117.91 100.224L170.362 124.682C172.995 125.91 176.126 124.771 177.354 122.138L208.329 55.7103L200.695 34.7349L157.78 14.7235C155.147 13.4955 152.016 14.6348 150.788 17.2683L115.366 93.2322C114.138 95.8657 115.277 98.996 117.91 100.224Z"
          fill="url(#paint2_linear_10643_40376)"
        />
        <path
          d="M200.695 34.7349L208.33 55.7102L194.025 49.0398L200.695 34.7349Z"
          fill="var(--border-strong)"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="154.406"
          id="filter0_dd_10643_40376"
          width="141.859"
          x="-1.55859"
          y="12.5312"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="erode"
            radius="4"
            result="effect1_dropShadow_10643_40376"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_10643_40376"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="erode"
            radius="4"
            result="effect2_dropShadow_10643_40376"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            in2="effect1_dropShadow_10643_40376"
            mode="normal"
            result="effect2_dropShadow_10643_40376"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_10643_40376"
            mode="normal"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="134.339"
          id="filter1_dd_10643_40376"
          width="108.398"
          x="62.8906"
          y="12.5"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="erode"
            radius="4"
            result="effect1_dropShadow_10643_40376"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_10643_40376"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="erode"
            radius="4"
            result="effect2_dropShadow_10643_40376"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            in2="effect1_dropShadow_10643_40376"
            mode="normal"
            result="effect2_dropShadow_10643_40376"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_10643_40376"
            mode="normal"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="154.406"
          id="filter2_dd_10643_40376"
          width="141.859"
          x="93.1406"
          y="12.5"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="erode"
            radius="4"
            result="effect1_dropShadow_10643_40376"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_10643_40376"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="erode"
            radius="4"
            result="effect2_dropShadow_10643_40376"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            in2="effect1_dropShadow_10643_40376"
            mode="normal"
            result="effect2_dropShadow_10643_40376"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_10643_40376"
            mode="normal"
            result="shape"
          />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_10643_40376"
          x1="59.9977"
          x2="18.1982"
          y1="124.919"
          y2="49.509"
        >
          <stop stopColor="#E4E7EC" />
          <stop offset="1" stopColor="#F9FAFB" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_10643_40376"
          x1="85.2725"
          x2="79.2587"
          y1="105.723"
          y2="19.7131"
        >
          <stop stopColor="#E4E7EC" />
          <stop offset="1" stopColor="#F9FAFB" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_10643_40376"
          x1="115.773"
          x2="146.672"
          y1="97.9951"
          y2="17.5024"
        >
          <stop stopColor="#E4E7EC" />
          <stop offset="1" stopColor="#F9FAFB" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default ThreeFilesIcon;
